import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';

registerBlockType('rielstonenew/gen-cattwo', {
  edit: Edit,
  save: Save,
});
